/**
 * @documental
 * @export Strikethrough
 * @type
 * typographyComponent
 * @use
 * The `Strikethrough` component should be used to identify text content which has been deleted or is incorrect.
 * @element
 * s
 * @className
 * strikethrough
 */
import { FC, PropsWithChildren } from "react";

import { BaseProps } from "../../BaseProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";

import styles from "./styles.module.scss";

/**
 * The Strikethrough component properties.
 */

export interface StrikethroughProps extends BaseProps {}

/**
 * Specifies that text content should be displayed as having a strike through line. Can be overridden
 * through the use of the [Underlined](../Underlined/README.md) component.
 */
export const Strikethrough: FC<PropsWithChildren<StrikethroughProps>> = (props) => {
  const { children } = props;
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, { className: [styles.Strikethrough, "strikethrough"] });

  return <s {...baseHtmlProps}>{children}</s>;
};
